import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var siteHeaderSearchButtonClicked = createAction(actionTypePrefix + ".SEARCH_BUTTON.CLICKED");
export var siteHeaderNotificationsOpened = createAction(actionTypePrefix + ".NOTIFICATIONS.OPENED");
export var siteHeaderWatchOpened = createAction(actionTypePrefix + ".WATCH.OPENED");
export var siteHeaderNotesOpened = createAction(actionTypePrefix + ".NOTES.OPENED");
export var openSubmitMenu = createAction(actionTypePrefix + ".SUBMIT.OPEN");
export var closeSubmitMenu = createAction(actionTypePrefix + ".SUBMIT.CLOSE");
export var openUserDropdown = createAction(actionTypePrefix + ".USER.OPEN");
export var closeUserDropdown = createAction(actionTypePrefix + ".USER.CLOSE");
export var openNotificationsDropdown = createAction(actionTypePrefix + ".NOTIFICATIONS.OPEN");
export var closeNotificationsDropdown = createAction(actionTypePrefix + ".NOTIFICATIONS.CLOSE");
export var openSearchPopup = createAction(actionTypePrefix + ".SEARCH.OPEN");
export var closeSearchPopup = createAction(actionTypePrefix + ".SEARCH.CLOSE");
//# sourceMappingURL=actions.js.map